import { request } from './core';

export interface InvoiceLine {
  ID: string;
  InvoiceID: string;
  Description: string;
  Quantity: number;
  UnitCents: number;
  TotalCents: number;
  SortOrder: number;
}

export type InvoiceStatus = "draft" | "sent" | "paid" | "void";

export interface Invoice {
  ID: string;
  UserID: string;
  BookingID: string;
  ClientID: string;
  Number: string;
  Status: InvoiceStatus;
  Currency: string;
  SubtotalCents: number;
  TaxCents: number;
  TotalCents: number;
  Notes: string;
  DueDate: string | null;
  PaidAt: string | null;
  CreditOf: string | null;
  SentAt: string | null;
  Lines: InvoiceLine[];
  CreatedAt: string;
  UpdatedAt: string;
}

export const invoicesApi = {
  listInvoices: () => request<Invoice[]>("GET", "/api/v1/invoices"),
  getInvoice: (id: string) => request<Invoice>("GET", `/api/v1/invoices/${encodeURIComponent(id)}`),
  createInvoiceFromBooking: (bookingId: string) =>
    request<Invoice>("POST", "/api/v1/invoices", { booking_id: bookingId }),
  updateInvoice: (id: string, patch: { status?: InvoiceStatus; notes?: string; due_date?: string }) =>
    request<Invoice>("PUT", `/api/v1/invoices/${encodeURIComponent(id)}`, patch),
  markInvoicePaid: (id: string) =>
    request<Invoice>("POST", `/api/v1/invoices/${encodeURIComponent(id)}/mark-paid`, {}),
  markInvoiceSent: (id: string) =>
    request<Invoice>("POST", '/api/v1/invoices/' + encodeURIComponent(id) + '/mark-sent', {}),
  createCreditNote: (id: string) =>
    request<Invoice>("POST", '/api/v1/invoices/' + encodeURIComponent(id) + '/credit', {}),
  getInvoicePrintUrl: (id: string) => '/api/v1/invoices/' + encodeURIComponent(id) + '/print',
  voidInvoice: (id: string) =>
    request<Invoice>("POST", `/api/v1/invoices/${encodeURIComponent(id)}/void`, {}),
  replaceInvoiceLines: (id: string, lines: Array<{ description: string; quantity: number; unit_cents: number }>) =>
    request<Invoice>("PUT", `/api/v1/invoices/${encodeURIComponent(id)}/lines`, { lines }),
};
